import { configureStore, combineReducers } from '@reduxjs/toolkit';

import { persistMiddleware } from '@/store/persist-middleware';

import { authReducerName, authReducer } from './reducers/auth-reducer';
import { generalReducer, generalReducerName } from './reducers/general-reducer';

const rootReducer = combineReducers({
  [authReducerName]: authReducer,
  [generalReducerName]: generalReducer
});

export type RootState = ReturnType<typeof rootReducer>;

export const makeStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(persistMiddleware)
  });
};

export type AppStore = ReturnType<typeof makeStore>;
export type AppDispatch = AppStore['dispatch'];
